import { Box, Button, Grid, Typography, Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';

import PinDropIcon from '@mui/icons-material/PinDrop';
import { useAppSelector, useAppDispatch } from '@store/hooks';
import { tokenSelector, getFeaturedTokensAction } from '@store/slices/token.slice';
import { useEffect } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { Pagination } from '@interfaces/pagination';
import { IToken } from '@interfaces/token';
import { AppSlider } from '@shared/components/Slider';
import { FeaturedTokenSkeleton } from '@shared/skeletons/FeaturedTokenSkeleton';

const useStyles = makeStyles((theme: Theme) => ({
    tokenLabel: {
        textTransform: 'uppercase',
        color: '#475569',
        fontSize: '10px !important',
        lineHeight: '12px !important',
        fontWeight: '700 !important' as 'bold'
    },
    tokenTitle: {
        color: '#000000',
        fontSize: '34px !important',
        fontWeight: '700 !important' as 'bold'
    },
    imageContainer: {
        maxWidth: '666px',
        maxHeight: '333px'
    },
    featuredImage: {
        maxWidth: '100%',
        maxHeight: '100%',
        alignItems: 'center'
    },
    tags: {
        padding: '5px 8px',
        display: 'flex',
        alignItems: 'center',
        fontSize: '12px',
        color: '#009F4D',
        backgroundColor: 'rgba(0, 159, 77, 0.1);',
        borderRadius: '34px',
        textTransform: 'none'
    },
    description: {
        fontWeight: '600 !important' as 'bold',
        color: '#475569',
        maxWidth: '255px'
    }
}));

export const FeaturedTokens = () => {
    const classes = useStyles();
    const tokenSlice = useAppSelector(tokenSelector);
    const dispatch = useAppDispatch();
    let history = useHistory();


    const getTokens = (pagination: Pagination) => {
        dispatch(getFeaturedTokensAction({ pagination }));
    }

    useEffect(() => {
        getTokens({ page: 1, limit: 1 })
    }, [])

    const featuredToken: IToken = tokenSlice?.recommendedTokens?.data && tokenSlice?.recommendedTokens?.data[0];
    if (tokenSlice?.featuredTokens?.data && tokenSlice?.featuredTokens?.data?.length == 0) return (<span></span>);
    return (
        <>
            {!tokenSlice?.featuredTokenLoaded ? (
                <FeaturedTokenSkeleton />

            ) :
                <Grid container spacing={4} mt={4}>
                    <Grid item md={4} xs={12}>
                        <Typography className={classes.tokenLabel} mt={4}>
                            Featured Memberships
                        </Typography>
                        <Typography className={classes.tokenTitle} mb={1}>
                            {featuredToken?.profile?.title}
                        </Typography>
                        <Box display="flex" mb={1}>
                            <Box className={classes.tags} mr={2}>
                                <PinDropIcon />
                                <Typography>
                                    {featuredToken?.profile?.category?.name}
                                </Typography>
                            </Box>
                            <Box className={classes.tags}>
                                <PinDropIcon />
                                <Typography>
                                    {featuredToken?.owner?.city}, {featuredToken?.owner?.state}
                                </Typography>
                            </Box>
                        </Box>
                        <Typography mb={2} className={classes.description}>
                            {featuredToken?.profile?.description}
                        </Typography>
                        <Button variant='contained' className={'button w-100'} component={Link} to={`/business-page/${featuredToken?.business?.id}`}>
                            <Typography fontWeight={700} className={'button-label'}>
                                Learn more
                            </Typography>
                        </Button>
                    </Grid>
                    <Grid item md={8} xs={12}>
                        <Box sx={{ display: 'flex', justifyContent: { sm: 'center', md: 'flex-end' } }}>
                            <Box className={classes.imageContainer}>
                                <AppSlider images={featuredToken?.profile?.covers?.map(x => x.file)} />
                            </Box>
                        </Box>
                    </Grid>
                </Grid>
            }

        </>
    )
}
